import { Instance } from '../../meta/types/wms/Instance';

export const toDropdownItemOptions = (instances: Instance[], icon = 'settings') => {
  return instances.map(instance => ({
    value: instance.id,
    text: instance.name,
    key: instance.id,
    icon,
  }));
};

export const UUID_PLACEHOLDER = 'nnnnnnnn-nnnn-nnnn-nnnn-nnnnnnnnnnnn';

export const SECTION_DROPDOWN_VALUE = '_null_';

export const getSectionDropdownOption = (text: string, key: any) => {
  return {
    text,
    value: SECTION_DROPDOWN_VALUE,
    key,
  };
};

export const formatNumber = (x: number, roundedDigits?: number, fixed = false): string => {
  let result: string;
  if (roundedDigits !== undefined) {
    const roundedResult = Math.round(x * 10 ** roundedDigits) / 10 ** roundedDigits;
    if (fixed) {
      result = roundedResult.toFixed(roundedDigits);
    } else {
      result = roundedResult.toString();
    }
  } else {
    result = x.toString();
  }
  result = result.replace(/\B(?=(\d{3})+(?!\d))/g, '\u2009');
  // Remove whitespaces on the decimal part.
  const splitted = result.split('.');
  if (splitted.length > 1 && splitted[1].length > 3) {
    splitted[1] = splitted[1].replace(/\s+/, '');
    return splitted.join('.');
  }
  return result;
};
